/**
 * Meta CAPI Parameter Builder (client-side).
 * Grava _fbc/_fbp no dominio e le click IDs para o checkout/CAPI.
 * Nao substitui o Pixel nem o envio server-side.
 */
function resolveBuilderApi(mod) {
  let current = mod;

  for (let depth = 0; depth < 3 && current; depth += 1) {
    if (typeof current.processAndCollectAllParams === "function") {
      return current;
    }
    current = current.default;
  }

  return null;
}

function loadBuilder() {
  try {
    // UMD da Meta expoe as funcoes no module.exports, nao em .default.
    // eslint-disable-next-line global-require
    return resolveBuilderApi(require("meta-capi-param-builder-clientjs"));
  } catch {
    if (typeof window !== "undefined") {
      return resolveBuilderApi(window.clientParamBuilder);
    }
    return null;
  }
}

const builder = loadBuilder();

const META_CLICK_ID_PATTERN = /^fb\.\d\.\d{13}\..+$/;

function setCookie(name, value, maxAgeSeconds = 7776000) {
  if (typeof document === "undefined" || !value) return;
  const secure =
    typeof window !== "undefined" && window.location?.protocol === "https:"
      ? "; Secure"
      : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax${secure}`;
}

/**
 * Se o landing (futuretrade.com.br) mandou _fbp/_fbc na query, grava no dominio do login
 * antes do Parameter Builder rodar — ponte cross-domain.
 */
export function seedMetaCookiesFromQuery() {
  if (typeof window === "undefined") return;

  try {
    const params = new URLSearchParams(window.location.search);
    const fbp = params.get("_fbp") || params.get("fbp");
    const fbc = params.get("_fbc") || params.get("fbc");
    if (fbp && META_CLICK_ID_PATTERN.test(fbp)) setCookie("_fbp", fbp);
    if (fbc && META_CLICK_ID_PATTERN.test(fbc)) setCookie("_fbc", fbc);
  } catch {
    // ignore
  }
}

export async function captureMetaClickParams() {
  if (typeof window === "undefined" || !builder) return null;

  try {
    seedMetaCookiesFromQuery();
    return await builder.processAndCollectAllParams(window.location.href);
  } catch (error) {
    console.warn("Meta param builder: falha ao coletar fbc/fbp", error);
    return null;
  }
}

export function getMetaClickIds() {
  if (typeof window === "undefined" || !builder) {
    return { fbc: "", fbp: "" };
  }

  try {
    return {
      fbc: builder.getFbc?.() || "",
      fbp: builder.getFbp?.() || "",
    };
  } catch {
    return { fbc: "", fbp: "" };
  }
}
